var map = {
	"./01.jpg": 3700,
	"./02.jpg": 7859,
	"./03.jpg": 1398,
	"./04.jpg": 6157,
	"./05.jpg": 5024,
	"./06.jpg": 8639,
	"./07.jpg": 6258,
	"./08.jpeg": 1838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9962;